<template>
  <div class="integrations-container10">
    <app-navigation></app-navigation>
        <section id="integrations-hero" class="integrations-thq-integrations-hero1-elm integrations-hero11">
          <div class="hero-video-wrapper">
            <video id="hero-video" src="https://vlecadblob.blob.core.windows.net/vlecad-website-mp4/Media/Sequence%2002%20(4).mp4"
              loop="true" muted="true" autoplay="true" playsinline="true" class="hero-bg-video"></video>
            <div class="hero-overlay1"></div>
          </div>
          <div class="hero-content1">
            <div class="hero-badge-group">
              <span class="hero-badge2">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('integrations.hero.badges.oneClick') }}</span>
              </span>
              <span class="hero-badge2">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="m16 18l6-6l-6-6M8 6l-6 6l6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('integrations.hero.badges.restApi') }}</span>
              </span>
              <span class="hero-badge2">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </g>
                </svg>
                <span>{{ $t('integrations.hero.badges.machinePark') }}</span>
              </span>
            </div>
            <h1 class="hero-title">{{ $t('integrations.hero.title') }}</h1>
            <p class="hero-subtitle">
              <span>{{ $t('integrations.hero.subtitle1') }}</span>
              <br />
              <br />
              <span>{{ $t('integrations.hero.subtitle2') }}
                <span v-html="rawjzjt"></span>
              </span>
            </p>
            <div class="hero-cta-group2">
              <router-link to="/contactdemo" class="integrations-thq-btn-elm1 btn btn-lg btn-primary">
                {{ $t('common.scheduleDemo') }}
              </router-link>
              <a href="#cnc-brands">
                <div class="btn btn-lg btn-outline btn2">
                  <span>
                    {{ $t('integrations.hero.actions.viewIntegrations') }}
                    <span v-html="rawb6tl"></span>
                  </span>
                </div>
              </a>
            </div>
          </div>
          <div class="hero-scroll-indicator1">
            <span>{{ $t('common.scrollForMore') }}</span>
            <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
              <path d="m5 12l7-7l7 7m-7 7V5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </div>
        </section>
      </div>
      <div>
        <div>
          <div>
            <section id="cnc-brands" class="cnc-brands">
              <div class="section-header">
                <span class="section-tag">
                  {{ $t('integrations.cnc.title') }}
                </span>
                <h2 class="section-title">{{ $t('integrations.cnc.subtitle') }}</h2>
                <p class="section-subtitle">{{ $t('integrations.cnc.description') }}
                  <span v-html="rawqagb"></span>
                </p>
              </div>
              <div class="brands-grid">
                <div class="brand-card">
                  <div class="brand-card-header">
                    <div class="brand-logo-placeholder">
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M12 20v2m0-20v2m5 16v2m0-20v2M2 12h2m-2 5h2M2 7h2m16 5h2m-2 5h2M20 7h2M7 20v2M7 2v2"></path>
                          <rect x="4" y="4" rx="2" width="16" height="16"></rect>
                          <rect x="8" y="8" rx="1" width="8" height="8"></rect>
                        </g>
                      </svg>
                    </div>
                    <span class="integrations-thq-brand-status-elm1 brand-status">
                      {{ $t('integrations.cnc.labels.certified') }}
                    </span>
                  </div>
                  <h3 class="brand-name">{{ $t('integrations.cnc.brands.homag.name') }}</h3>
                  <p class="brand-description">{{ $t('integrations.cnc.brands.homag.description') }}
                    <span v-html="raw0ikz"></span>
                  </p>
                  <ul class="brand-features">
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.homag.postprocessor') }}</span>
                    </li>
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.homag.labels') }}</span>
                    </li>
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.homag.crashCheck') }}</span>
                    </li>
                  </ul>
                  <img alt="CNC machine in action, precisely cutting a wooden panel with sawdust flying." src="/iv%20interior_cnc-1500h.jpg" loading="lazy" class="brand-image"/>
                </div>
                <div class="brand-card">
                  <div class="brand-card-header">
                    <div class="brand-logo-placeholder">
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M12 20v2m0-20v2m5 16v2m0-20v2M2 12h2m-2 5h2M2 7h2m16 5h2m-2 5h2M20 7h2M7 20v2M7 2v2"></path>
                          <rect x="4" y="4" rx="2" width="16" height="16"></rect>
                          <rect x="8" y="8" rx="1" width="8" height="8"></rect>
                        </g>
                      </svg>
                    </div>
                    <span class="integrations-thq-brand-status-elm2 brand-status">
                      {{ $t('integrations.cnc.labels.certified') }}
                    </span>
                  </div>
                  <h3 class="brand-name">{{ $t('integrations.cnc.brands.scm.name') }}</h3>
                  <p class="brand-description">{{ $t('integrations.cnc.brands.scm.description') }}
                    <span v-html="raw1342"></span>
                  </p>
                  <ul class="brand-features">
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.scm.oneclick') }}</span>
                    </li>
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.scm.speed') }}</span>
                    </li>
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.scm.toolpath') }}</span>
                    </li>
                  </ul>
                  <img alt="Close-up of a high precision CNC milling tool used for metalworking in industrial settings." src="/20250430_122314%20-cnc-1500h.jpg" loading="lazy" class="brand-image"/>
                </div>
                <div class="brand-card">
                  <div class="brand-card-header">
                    <div class="brand-logo-placeholder">
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M12 20v2m0-20v2m5 16v2m0-20v2M2 12h2m-2 5h2M2 7h2m16 5h2m-2 5h2M20 7h2M7 20v2M7 2v2"></path>
                          <rect x="4" y="4" rx="2" width="16" height="16"></rect>
                          <rect x="8" y="8" rx="1" width="8" height="8"></rect>
                        </g>
                      </svg>
                    </div>
                    <span class="integrations-thq-brand-status-elm3 brand-status">
                      {{ $t('integrations.cnc.labels.certified') }}
                    </span>
                  </div>
                  <h3 class="brand-name">{{ $t('integrations.cnc.brands.biesse.name') }}</h3>
                  <p class="brand-description">
                    <span>{{ $t('integrations.cnc.brands.biesse.description') }}</span>
                  </p>
                  <ul class="brand-features">
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.biesse.biesse') }}</span>
                    </li>
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.biesse.batch') }}</span>
                    </li>
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.biesse.realtime') }}</span>
                    </li>
                  </ul>
                  <img alt="A close-up shot of a CNC machine operating in a workshop with a technician nearby." src="/refra_cnc-1500h.jpg" loading="lazy" class="brand-image"/>
                </div>
                <div class="brand-card">
                  <div class="brand-card-header">
                    <div class="brand-logo-placeholder">
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M12 20v2m0-20v2m5 16v2m0-20v2M2 12h2m-2 5h2M2 7h2m16 5h2m-2 5h2M20 7h2M7 20v2M7 2v2"></path>
                          <rect x="4" y="4" rx="2" width="16" height="16"></rect>
                          <rect x="8" y="8" rx="1" width="8" height="8"></rect>
                        </g>
                      </svg>
                    </div>
                    <span class="integrations-thq-brand-status-elm4 brand-status">
                      {{ $t('integrations.cnc.labels.partner') }}
                    </span>
                  </div>
                  <h3 class="brand-name">{{ $t('integrations.cnc.brands.holzher.name') }}</h3>
                  <p class="brand-description">{{ $t('integrations.cnc.brands.holzher.description') }}
                    <span v-html="rawhvxx"></span>
                  </p>
                  <ul class="brand-features">
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.holzher.fiveAxis') }}</span>
                    </li>
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.holzher.automation') }}</span>
                    </li>
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.holzher.nesting') }}</span>
                    </li>
                  </ul>
                  <img alt="A detailed view of a CNC machine being operated by a person indoors with dim lighting." src="/vlecad-8093-1500h.jpg" loading="lazy" class="brand-image"/>
                </div>
                <div class="brand-card">
                  <div class="brand-card-header">
                    <div class="brand-logo-placeholder">
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M12 20v2m0-20v2m5 16v2m0-20v2M2 12h2m-2 5h2M2 7h2m16 5h2m-2 5h2M20 7h2M7 20v2M7 2v2"></path>
                          <rect x="4" y="4" rx="2" width="16" height="16"></rect>
                          <rect x="8" y="8" rx="1" width="8" height="8"></rect>
                        </g>
                      </svg>
                    </div>
                    <span class="integrations-thq-brand-status-elm5 brand-status">
                      {{ $t('integrations.cnc.labels.partner') }}
                    </span>
                  </div>
                  <h3 class="brand-name">{{ $t('integrations.cnc.brands.format.name') }}</h3>
                  <p class="brand-description">{{ $t('integrations.cnc.brands.format.description') }}
                    <span v-html="rawut49"></span>
                  </p>
                  <ul class="brand-features">
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.format.batch') }}</span>
                    </li>
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.format.quality') }}</span>
                    </li>
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.format.production') }}</span>
                    </li>
                  </ul>
                  <img alt="Close-up of a CNC milling machine working on metal for precise manufacturing." src="/vlecad-1282-1024x683-1500h.jpg" loading="lazy" class="brand-image"/>
                </div>
                <div class="brand-card">
                  <div class="brand-card-header">
                    <div class="brand-logo-placeholder">
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M12 20v2m0-20v2m5 16v2m0-20v2M2 12h2m-2 5h2M2 7h2m16 5h2m-2 5h2M20 7h2M7 20v2M7 2v2"></path>
                          <rect x="4" y="4" rx="2" width="16" height="16"></rect>
                          <rect x="8" y="8" rx="1" width="8" height="8"></rect>
                        </g>
                      </svg>
                    </div>
                    <span class="integrations-thq-brand-status-elm6 brand-status">
                      Compatible
                    </span>
                  </div>
                  <h3 class="brand-name">{{ $t('integrations.cnc.brands.more.name') }}</h3>
                  <p class="brand-description">
                    <span>{{ $t('integrations.cnc.brands.more.description1') }}</span>
                  </p>
                  <ul class="brand-features">
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.more.gcode') }}</span>
                    </li>
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.more.custom') }}</span>
                    </li>
                    <li>
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('integrations.cnc.brands.more.label') }}</span>
                    </li>
                  </ul>
                  <img alt="Close-up view of a worker grinding metal, showcasing precision and craftsmanship in industrial setting." src="/20250429_175035%20-%20nesting%20cnc-1500h.jpg" loading="lazy" class="brand-image"/>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <section id="nesting-software" class="nesting-software">
        <div class="nesting-content-wrapper">
          <div class="nesting-visual">
            <div class="nesting-visual-inner">
              <img alt="Close-up of a technician using a digital controller in an industrial setting, emphasizing technology and precision." src="/vlecad-8080-1500w.jpg" loading="lazy" class="nesting-main-image"/>
              <div class="nesting-overlay-card">
                <div class="nesting-stat">
                  <span class="nesting-stat-number">96%</span>
                  <span class="nesting-stat-label">{{ $t('integrations.nesting.stats.materialUsage') }}</span>
                </div>
                <div class="nesting-efficiency-bar">
                  <div class="nesting-efficiency-fill"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="nesting-content">
            <span class="section-tag">{{ $t('integrations.nesting.title') }}</span>
            <h2 class="section-title">{{ $t('integrations.nesting.subtitle') }}</h2>
            <p class="section-content">{{ $t('integrations.nesting.description') }}
            </p>
            <div class="nesting-features-list">
              <div class="nesting-feature-item">
                <div class="nesting-feature-icon">
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>
                      <path d="m3.3 7l8.7 5l8.7-5M12 22V12"></path>
                    </g>
                  </svg>
                </div>
                <div class="nesting-feature-content">
                  <h3 class="nesting-feature-title">
                    {{ $t('integrations.nesting.features.cuttingList') }}
                  </h3>
                  <p class="nesting-feature-description">{{ $t('integrations.nesting.features.cuttingListTxt') }}</p>
                </div>
              </div>
              <div class="nesting-feature-item">
                <div class="nesting-feature-icon">
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                      fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </div>
                <div class="nesting-feature-content">
                  <h3 class="nesting-feature-title">
                    {{ $t('integrations.nesting.features.staydown') }}
                  </h3>
                  <p class="nesting-feature-description">{{ $t('integrations.nesting.features.staydownTxt') }}</p>
                </div>
              </div>
              <div class="nesting-feature-item">
                <div class="nesting-feature-icon">
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                    </g>
                  </svg>
                </div>
                <div class="nesting-feature-content">
                  <h3 class="nesting-feature-title">
                    {{ $t('integrations.nesting.features.export') }}
                    <span v-html="rawh5t5"></span>
                  </h3>
                  <p class="nesting-feature-description">{{ $t('integrations.nesting.features.exportTxt') }}</p>
                </div>
              </div>
            </div>
            <a href="https://www.autofitsoftware.com/" target="_blank" rel="noreferrer noopener" class="integrations-thq-btn-elm2 btn btn-primary">
              {{ $t('integrations.nesting.cta.visit') }}
            </a>
          </div>
        </div>
      </section>
      <section id="production-equipment" class="production-equipment">
        <div class="section-header">
          <span class="section-tag">{{ $t('integrations.equipment.title') }}</span>
          <h2 class="section-title">
            {{ $t('integrations.equipment.subtitle') }}
          </h2>
          <p class="section-subtitle">
            <span><span v-html="rawkghl"></span></span>
            <br />
            <span>
              {{ $t('integrations.equipment.description') }}
              <span v-html="rawhtzd"></span>
            </span>
          </p>
        </div>
        <div class="equipment-grid">
          <div class="equipment-card equipment-card-large">
            <div class="equipment-card-visual">
              <img alt="Detailed view of an industrial canning process with aluminum cans on an automatic assembly line." src="/vlecad_170628_lr_15_sv5_0395-1500h.jpg" loading="lazy"/>
              <div class="equipment-card-overlay">
                <div class="equipment-icon">
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                      <circle r="3" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div class="equipment-card-content">
              <h3 class="equipment-card-title">{{ $t('integrations.equipment.types.beamsaw') }}</h3>
              <p class="equipment-card-description">{{ $t('integrations.equipment.types.beamsawTxt') }}</p>
              <ul class="equipment-features">
                <li>
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('integrations.equipment.types.beamsawOpt1') }}</span>
                </li>
                <li>
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('integrations.equipment.types.beamsawOpt2') }}</span>
                </li>
                <li>
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('integrations.equipment.types.beamsawOpt3') }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="equipment-card">
            <div class="equipment-card-visual">
              <img alt="Detailed view of a brewery machinery used for labeling beer cans in an industrial setting." src="/vlecad_170628_lr_18_sv5_0475-1500h.jpg" loading="lazy"/>
              <div class="equipment-card-overlay">
                <div class="equipment-icon">
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                      <circle r="3" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div class="equipment-card-content">
              <h3 class="equipment-card-title">{{ $t('integrations.equipment.types.edgebanding') }}</h3>
              <p class="equipment-card-description">{{ $t('integrations.equipment.types.edgebandingTxt') }}</p>
              <ul class="equipment-features">
                <li>
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('integrations.equipment.types.edgebandingOpt1') }}</span>
                </li>
                <li>
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('integrations.equipment.types.edgebandingOpt2') }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="equipment-card">
            <div class="equipment-card-visual">
              <img alt="High-tech industrial machinery inside a modern factory. Pipes and equipment dominate the space." src="/vlecad_170628_lr_40_sv5_0677-1500h.jpg" loading="lazy"/>
              <div class="equipment-card-overlay">
                <div class="equipment-icon">
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                      <path d="M3 5v14a9 3 0 0 0 18 0V5"></path>
                      <path d="M3 12a9 3 0 0 0 18 0"></path>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div class="equipment-card-content">
              <h3 class="equipment-card-title">{{ $t('integrations.equipment.types.storage') }}</h3>
              <p class="equipment-card-description">{{ $t('integrations.equipment.types.storageTxt') }}</p>
              <ul class="equipment-features">
                <li>
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('integrations.equipment.types.storageOpt1') }}</span>
                </li>
                <li>
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('integrations.equipment.types.storageOpt2') }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section id="rest-api" class="rest-api">
        <div class="api-video-background">
          <video id="api-video" src="https://videos.pexels.com/video-files/852388/852388-hd_1920_1080_24fps.mp4" loop="true" muted="true" poster="https://images.pexels.com/videos/852388/pictures/preview-0.jpg" autoplay="true" playsinline="true" class="api-bg-video"></video>
          <div class="api-overlay"></div>
        </div>
        <div class="api-content-container">
          <div class="api-content">
            <span class="section-tag api-tag">REST API</span>
            <h2 class="api-title section-title">
              {{ $t('integrations.api.subtitle') }}
              <span v-html="rawcum2"></span>
            </h2>
            <p class="api-subtitle section-subtitle">{{ $t('integrations.api.description') }}</p>
            <div class="api-features-grid">
              <div class="api-feature-card">
                <div class="api-feature-icon">
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <path d="m16 18l6-6l-6-6M8 6l-6 6l6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </div>
                <h3 class="api-feature-title">{{ $t('integrations.api.features.configurator') }}</h3>
                <p class="api-feature-description">{{ $t('integrations.api.features.configuratorTxt') }}</p>
              </div>
              <div class="api-feature-card">
                <div class="api-feature-icon">
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                      <path d="M3 5v14a9 3 0 0 0 18 0V5"></path>
                      <path d="M3 12a9 3 0 0 0 18 0"></path>
                    </g>
                  </svg>
                </div>
                <h3 class="api-feature-title">{{ $t('integrations.api.features.erp') }}</h3>
                <p class="api-feature-description">{{ $t('integrations.api.features.erpTxt') }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="final-cta" class="final-cta">
        <div class="cta-container">
          <div class="cta-content">
            <h2 class="cta-title">{{ $t('integrations.cta.title') }}</h2>
            <p class="cta-subtitle">
              <span>{{ $t('integrations.cta.subtitle1') }}</span>
              <br />
              <span>{{ $t('integrations.cta.subtitle2') }}</span>
            </p>
            <div class="cta-button-group">
              <router-link to="/contactdemo" class="integrations-thq-btn-elm5 btn btn-xl btn-primary">
                <button @click="scrollToTop">
                  {{ $t('common.scheduleDemo') }}
                </button>
              </router-link>
            </div>
            <div class="cta-trust-indicators">
              <div class="trust-indicator">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('integrations.cta.trust.noObligations') }}</span>
              </div>
              <div class="trust-indicator">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('integrations.cta.trust.demoOnSite') }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    <app-footer></app-footer>
</template>

<script>
import { useHead } from '@vueuse/head'

import AppNavigation from '../components/navigation'
import AppFooter from '../components/footer'

export default {
  name: 'Integrations',
  props: {},
  components: {
    AppNavigation,
    AppFooter,
  },
  setup() {
    // Vue 3 migration: move metaInfo into useHead.
    useHead({
      title: 'Integrations - KORPUS by VLECAD®',
      meta: [
        {
          name: 'description',
          content:
            'KORPUS by VLECAD®: From design to CNC in one click. CAD/CAM that thinks like a craftsman for interior builders and cabinet shops. Book a demo.',
        },
        {
          property: 'og:title',
          content: 'Integrations - KORPUS by VLECAD®',
        },
        {
          property: 'og:description',
          content:
            'KORPUS by VLECAD®: From design to CNC in one click. CAD/CAM that thinks like a craftsman for interior builders and cabinet shops. Book a demo.',
        },
        {
          property: 'og:image',
          content:
            'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/ebedf48f-c2b5-4ca6-808d-9d940905bddf/993061ae-1787-4b73-9fda-47262adc60d9?org_if_sml=1&force_format=original',
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://hospitable-imperfect-heron-qlicxu.teleporthq.app/integrations',
        },
      ],
    })
  },
  data() {
    return {
      rawjzjt: ' ',
      rawb6tl: ' ',
      rawqagb: ' ',
      raw0ikz: ' ',
      raw1342: ' ',
      rawkkwp: ' ',
      raw82nd: ' ',
      rawhvxx: ' ',
      rawut49: ' ',
      rawsnh4: ' ',
      rawul9c: ' ',
      rawh5t5: ' ',
      rawkghl: ' ',
      rawhtzd: ' ',
      raw32tm: ' ',
      rawmjkz: ' ',
      rawcum2: ' ',
      rawo9wi: ' ',
      raw4vpf: ' ',
      raww832: ' ',
      rawkows: ' ',
      rawj5r0: ' ',
      rawvo2l: ' ',
      rawu0wy: ' ',
      raw8n95: ' ',
      rawo5f2: ' ',
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }    
  }
}
</script>

<style>
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(2rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes float {
  0%,
  100% {
    transform: translate(-50%, 0);
  }
  50% {
    transform: translate(-50%, 0.75rem);
  }
}
@keyframes fillBar {
  from {
    width: 0;
  }
  to {
    width: 96%;
  }
}
@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.3;
  }
}
* {
  transition: background-color var(--animation-duration-standard)
      var(--animation-curve-primary),
    color var(--animation-duration-standard) var(--animation-curve-primary),
    border-color var(--animation-duration-standard)
      var(--animation-curve-primary);
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>

<style scoped>
.integrations-container10 {
  width: 100%;
  display: block;
  min-height: 100vh;
}
 
.integrations-container11 {
  display: none;
}
 
.integrations-container12 {
  display: contents;
}
 
.integrations-container13 {
  display: none;
}
 
.integrations-container14 {
  display: contents;
}
 
.integrations-container15 {
  display: none;
}
 
.integrations-container16 {
  display: contents;
}
 
.integrations-thq-integrations-hero1-elm {
  width: auto;
}
 
.integrations-thq-btn-elm1 {
  text-decoration: none;
}
 
.integrations-thq-brand-status-elm1 {
  display: none;
}
 
.integrations-thq-brand-status-elm2 {
  display: none;
}
 
.integrations-thq-brand-status-elm3 {
  display: none;
}
 
.integrations-thq-brand-status-elm4 {
  display: none;
}
 
.integrations-thq-brand-status-elm5 {
  display: none;
}
 
.integrations-thq-brand-status-elm6 {
  display: none;
}
 
.integrations-thq-btn-elm2 {
  text-decoration: none;
}
 
.integrations-thq-api-feature-card-elm3 {
  display: none;
}
 
.integrations-thq-api-feature-card-elm4 {
  display: none;
}
 
.integrations-thq-api-code-preview-elm {
  display: none;
}
 
.integrations-thq-btn-elm3 {
  display: none;
}
 
.integrations-thq-integration-benefits-elm {
  display: none;
}
 
.integrations-thq-benefit-stat-fill-elm1 {
  stroke-dasharray: 85 100;
}
 
.integrations-thq-benefit-stat-fill-elm2 {
  stroke-dasharray: 96 100;
}
 
.integrations-thq-benefit-stat-fill-elm3 {
  stroke-dasharray: 92 100;
}
 
.integrations-thq-btn-elm5 {
  text-decoration: none;
}
 
.integrations-thq-btn-elm6 {
  display: none;
}
 
.integrations-thq-trust-indicator-elm3 {
  display: none;
}
</style>
